export const USER_PAGE_URL_PART = 'users'
export const PERSONAL_PAGE_URL_PART = 'settings'
export const PERSONAL_SETTINGS_URL_PART = 'edit'
